function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("polygon", {
  id: "users-a",
  points: "0 0 18 0 18 8 0 8"
}),
/*#__PURE__*/
React.createElement("polygon", {
  id: "users-c",
  points: "0 .063 8.389 .063 8.389 8 0 8"
}),
/*#__PURE__*/
React.createElement("polygon", {
  id: "users-e",
  points: "0 0 6 0 6 9 0 9"
}));

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0 2)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(4 10)"
},
/*#__PURE__*/
React.createElement("mask", {
  id: "users-b",
  fill: "#fff"
},
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#users-a"
})),
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1.0088,8 C0.9438,8 0.8758,7.994 0.8098,7.98 C0.2638,7.872 -0.0902,7.344 0.0198,6.803 C0.6658,3.618 3.2188,1.054 6.6848,0.112 C7.1078,-0.002 7.5518,0.084 7.9038,0.349 C8.2548,0.615 8.4638,1.033 8.4638,1.47 L8.4638,2.05 L9.7418,0.513 C10.0858,0.102 10.6448,-0.086 11.1618,0.038 C14.4608,0.819 17.0588,3.139 17.9398,6.092 C18.0718,6.542 17.9848,7.016 17.6998,7.394 C17.4138,7.773 16.9578,8 16.4818,8 L13.0988,8 C12.5408,8 12.0908,7.552 12.0908,7 C12.0908,6.448 12.5408,6 13.0988,6 L15.7668,6 C14.9658,4.149 13.2308,2.696 11.0548,2.077 L8.9448,4.613 C8.5608,5.074 7.9458,5.241 7.3798,5.039 C6.8148,4.836 6.4478,4.32 6.4478,3.723 L6.4478,2.29 C4.1178,3.168 2.4428,4.993 1.9958,7.197 C1.8998,7.672 1.4788,8 1.0088,8",
  mask: "url(#users-b)"
})),
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M13,0 C10.8,0 9,1.8 9,4 L9,5 C9,7.2 10.8,9 13,9 C15.2,9 17,7.2 17,5 L17,4 C17,1.8 15.2,0 13,0 M13,2 C14.103,2 15,2.897 15,4 L15,5 C15,6.103 14.103,7 13,7 C11.897,7 11,6.103 11,5 L11,4 C11,2.897 11.897,2 13,2"
}),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 10)"
},
/*#__PURE__*/
React.createElement("mask", {
  id: "users-d",
  fill: "#fff"
},
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#users-c"
})),
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M6.4483,2.4819 C7.0203,1.9329 7.6693,1.4499 8.3893,1.0489 C8.3023,0.7749 8.1383,0.5269 7.9033,0.3489 C7.5523,0.0839 7.1073,-0.0021 6.6843,0.1119 C3.2193,1.0539 0.6663,3.6179 0.0193,6.8029 C-0.0897,7.3439 0.2633,7.8719 0.8083,7.9809 C0.8763,7.9939 0.9433,7.9999 1.0093,7.9999 C1.4783,7.9999 1.8993,7.6719 1.9963,7.1969 C2.4423,4.9929 4.1183,3.1679 6.4483,2.2899 L6.4483,2.4819 Z",
  mask: "url(#users-d)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(5)"
},
/*#__PURE__*/
React.createElement("mask", {
  id: "users-f",
  fill: "#fff"
},
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#users-e"
})),
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M4.5176,6.9238 C4.3516,6.9678 4.1796,6.9998 3.9996,6.9998 C2.8976,6.9998 1.9996,6.1028 1.9996,4.9998 L1.9996,3.9998 C1.9996,2.8978 2.8976,1.9998 3.9996,1.9998 C4.1796,1.9998 4.3516,2.0318 4.5176,2.0758 C4.8686,1.4458 5.3776,0.9228 5.9996,0.5588 C5.4086,0.2128 4.7306,-0.0002 3.9996,-0.0002 C1.7996,-0.0002 -0.0004,1.7998 -0.0004,3.9998 L-0.0004,4.9998 C-0.0004,7.1998 1.7996,8.9998 3.9996,8.9998 C4.7306,8.9998 5.4086,8.7868 5.9996,8.4408 C5.3776,8.0768 4.8686,7.5538 4.5176,6.9238",
  mask: "url(#users-f)"
})));

var SvgUsers = function SvgUsers(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22"
    }, props), _ref, _ref2)
  );
};

export default SvgUsers;